import {ui} from "./utils/ui";
import {home} from "./features/home";

export default () => {
    if (ui.attachments) {
        home(ui.attachments);
    }

    if (ui.worksLikeYou) {
        home(ui.worksLikeYou);
    }
};
